export default "__VITE_ASSET__FFgTTDAk__"